export const AddressColumns = [
    "Country",
    "Delivary_address",
    "Buyeradderss"
]